import { Filters, List, Page, Row, SearchInput, SpellListItem } from '../../components';
import './SpellsReferencePage.scss';

import { SPELLS } from '../../data';
import { useContext, useRef } from 'react';
import { applyAllFilters } from '../../util/spell';
import { ActiveListContext } from '../../context/ActiveListContext';
import { AuthContext, FilterContext, SettingsContext } from '../../context';
import { Alert, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const SpellsReferencePage = () => {
    const { isLoggedIn } = useContext(AuthContext);
    const context = useContext(FilterContext) || {
        searchString: '',
        setSearchString: () => {},
        filters: {},
        setFilters: () => {},
    };
    const { searchString, setSearchString, filters, setFilters } = context;

    const {
        activeList,
        addSpell,
        hasSpell,
        removeSpell,
    } = useContext(ActiveListContext);
    const scrollRef = useRef(null);
    const settings = useContext(SettingsContext);

    const compareSpells = (s1, s2) => {
        if (s1.level === s2.level) {
            return s1.name.localeCompare(s2.name);
        }

        return s1.level - s2.level;
    };

    const visibleSpells = SPELLS
        .filter(({ name }) => new RegExp(searchString.toLowerCase()).test(name.toLowerCase()))
        .filter(s => applyAllFilters(s, filters, settings))
        .sort(compareSpells);

    return (
        <Page className="SpellsReferencePage">
            {!isLoggedIn &&
                <Alert severity='info'>
                    <Link to="/emaillinksignin">Save your spell lists</Link> to keep your favorites synced and ready when you return.
                </Alert>
            }
            <Row className='headingRow'>
                <h2>{`All Spells (${visibleSpells.length})`}</h2>
                {isLoggedIn &&
                    <Button variant='contained' color='secondary' href="/lists">Lists</Button>
                }
            </Row>
            <SearchInput value={searchString} onChange={setSearchString} />
            <Filters filters={filters} onChange={setFilters} />
            <List ref={scrollRef}>
                {visibleSpells.map((s, i) => (
                    <SpellListItem
                        key={i}
                        spell={s}
                        addable={!!activeList}
                        added={hasSpell(s)}
                        onAdd={() => addSpell(s)}
                        onRemove={() => removeSpell(s)}
                    />
                ))}
            </List>
        </Page>
    );
};
